import React, { useEffect, useState } from 'react'
import { FormatMoney } from '../../../../Helpers/FormatNumber';
import { ValPedidoFinanciamiento } from '../../../Dashboard/Clientes/CapturasDashClientes/PedidoMaquinaria/Validators/ValPedidoFinanciamiento';
import Swal from 'sweetalert2';
import request from '../../../../Helpers/API';
import { Button, InputAdornment, MenuItem, Modal, TextField } from '@mui/material';
import { ValOnlyNumber } from '../../../../Validators/ValOnlyNumber';
import { ValTextAndNumber } from '../../../../Validators/ValTextAndNumber';
import { Moneda } from '../../../../Helpers/Moneda';
import PercentIcon from "@mui/icons-material/Percent";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import Agriculture from "@mui/icons-material/Agriculture";
import { LoaderScreen } from '../../../components/LoaderScreen';

export const ModalAgregarFinanciamiento = ({
    open,
    onClose,
    folio,
    docto = -1,
    tipoAmortizacion,
    valorInsoluto,
    actualizarLista
}) => {

    const [detalle, setDetalle] = useState({
        docto: "",
        vencimiento: "",
        importe: 0,
        dias: "",
        tasa: "",
        intereses: 0,
        totalpagar: 0,
        importe_solicitado: 0,
        inicio_interes: "",
        enganche: "M",
        bdocto: "",
        bvencimiento: "",
        binicio_interes: "",
        bimporte: "",
        bdias: "",
        btasa: "",
        bintereses: "",
        btotalpagar: "",
        benganche: "",
        bimportesolicitado: false,
    });
    
    const [insolutoAnterior, setInsolutoAnterior] = useState(0);
    const [insolutoEditado, setInsolutoEditado] = useState(0);

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const onChange = (prop, value, sbool, smensaje) => {
        const sinComas = value.replace(/,/g, "");
        setDetalle({
            ...detalle,
            [prop]: sinComas,
            ["b" + prop]: false,
            ["m" + prop]: "",
        });
    };
    const onFocus = (e) => {
        e.target.type = "number";
    };
    const onBlur = (e, prop) => {
        e.target.type = "text";
        e.target.value = FormatMoney(Number(detalle[prop]));
    };
    const onGuardar = () => {
        var result = ValPedidoFinanciamiento(detalle);
        if (result.isValid === false) {
            Swal.fire(
                "PEDIDO DE MAQUINARIA",
                JSON.stringify(result.mensaje),
                "error"
            );
        } else {
            result.post.folio = folio;
            result.post.docto = docto;
            result.post.tipo_amortizacion = tipoAmortizacion;
            result.post.valor_insoluto =
                tipoAmortizacion === "M" && result.post.docto === -1
                    ? valorInsoluto
                    : tipoAmortizacion === "M" &&
                        result.post.docto !== -1
                        ? insolutoEditado
                        : result.post.importefinanciar;
            request
                .post("PedidoFinanciamiento", result.post)
                .then(async () => {
                    onClose();
                    await Swal.fire(
                        "PEDIDO MAQUINARIA",
                        "Registro guardado con exito",
                        "success"
                    );
                    setDetalle({
                        ...detalle,
                        docto: "",
                        vencimiento: "",
                        importe: 0,
                        dias: "",
                        tasa: "",
                        intereses: 0,
                        totalpagar: 0,
                        importe_solicitado: 0,
                        inicio_interes: "",
                        bdocto: "",
                        bvencimiento: "",
                        binicio_interes: "",
                        bimporte: "",
                        bdias: "",
                        btasa: "",
                        bintereses: "",
                        btotalpagar: "",
                        bimportesolicitado: false,
                    });
                    actualizarLista()
                })
                .catch((error) => {
                    Swal.fire("PEDIDO DE MAQUINARIA", JSON.stringify(error), "info");
                });
        }
    };

    useEffect(() => {
        if (
            docto !== undefined &&
            docto !== null &&
            docto !== -1
        ) {
            setLoader({ ...loader, mostrar: true });
            request
                .get(
                    `PedidoFinanciamiento/GetByRegistro?folio=${folio}&docto=${docto}`
                )
                .then((result) => {
                    if (Number(result.importe_solicitado) === 0) {
                        Swal.fire(
                            "DETALLE DE PEDIDO",
                            "Ya se cubrio el total a financiar",
                            "info"
                        );
                        // closeModal();
                        return;
                    }
                    if (docto === -1) {
                        setDetalle({
                            ...detalle,
                            importe_solicitado: result.importe_solicitado,
                        });
                        setInsolutoAnterior(0);
                        return;
                    }
                    setDetalle({
                        ...detalle,
                        vencimiento: result.dvencimiento,
                        inicio_interes:
                            result.dinicio_interes === "0001-01-01"
                                ? ""
                                : result.dinicio_interes,
                        importe: result.importefinanciar,
                        dias: result.dias,
                        tasa: result.tasa,
                        intereses: result.interes,
                        totalpagar: result.totalpagar,
                        importe_solicitado: result.importe_solicitado,
                        enganche: result.interes === 0 ? "S" : "N",
                    });
                    setInsolutoAnterior(result.importefinanciar);
                    var financiamiento = document.getElementById("financiamineto");
                    if (financiamiento !== undefined && financiamiento !== null) {
                        financiamiento.value = FormatMoney(result.importefinanciar);
                    }
                    var intereses = document.getElementById("intereses");
                    if (intereses !== undefined && intereses !== null) {
                        intereses.value = FormatMoney(result.interes);
                    }

                    setLoader({ ...loader, mostrar: false });
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    Swal.fire(
                        "PEDIDO DE MAQUINARIA",
                        JSON.stringify(error),
                        "error"
                    );
                });
        }
        else {
            setDetalle({
                ...detalle,
                docto: "",
                vencimiento: "",
                importe: 0,
                dias: "",
                tasa: "",
                intereses: 0,
                totalpagar: 0,
                importe_solicitado: 0,
                bdocto: "",
                bvencimiento: "",
                bimporte: "",
                bdias: "",
                btasa: "",
                bintereses: "",
                btotalpagar: "",
                bimportesolicitado: false,
            })
        }
    }, [docto]);
    useEffect(() => {
        var importe =
            detalle.importe === undefined ||
                detalle.importe === null ||
                detalle.importe === ""
                ? 0
                : Number(detalle.importe);

        var tasa =
            detalle.tasa === undefined || detalle.tasa === null || detalle.tasa === ""
                ? 0
                : Number(detalle.tasa);

        var dias =
            detalle.dias === undefined || detalle.dias === null || detalle.dias === ""
                ? 0
                : Number(detalle.dias);

        // var intereses =
        //     importe === 0 || tasa === 0 || dias === 0
        //         ? 0
        //         : ((Number(importe) * Number(tasa)) / 100 / 360) * Number(dias);
        // setDetalle({
        //     ...detalle,
        //     totalpagar: Number(importe) + Number(intereses),
        //     intereses,
        // });
        if (
            tipoAmortizacion === "M" &&
            docto === -1 &&
            detalle.enganche !== "S"
        ) {
            var intereses =
                importe === 0 || tasa === 0 || dias === 0
                    ? 0
                    : ((Number(valorInsoluto) * Number(tasa)) /
                        100 /
                        360) *
                    Number(dias);
            setDetalle({
                ...detalle,
                totalpagar: Number(importe) + Number(intereses),
                intereses,
            });
        } else if (
            tipoAmortizacion === "M" &&
            docto !== -1 &&
            detalle.enganche !== "S"
        ) {
            const valorInsolutoTotal =
                Number(valorInsoluto) + Number(insolutoAnterior);
            var intereses =
                importe === 0 || tasa === 0 || dias === 0
                    ? 0
                    : ((Number(valorInsolutoTotal) * Number(tasa)) / 100 / 360) *
                    Number(dias);
            setDetalle({
                ...detalle,
                totalpagar: Number(importe) + Number(intereses),
                intereses,
            });
            setInsolutoEditado(valorInsolutoTotal);
        } else if (
            tipoAmortizacion === "M" &&
            docto !== -1 &&
            detalle.enganche === "S"
        ) {
            const valorInsolutoTotal =
                Number(valorInsoluto) + Number(insolutoAnterior);
            var intereses = 0;
            setDetalle({
                ...detalle,
                totalpagar: Number(importe) + Number(intereses),
                intereses,
            });
            setInsolutoEditado(valorInsolutoTotal);
        } else if (
            tipoAmortizacion === "M" &&
            docto === -1 &&
            detalle.enganche === "S"
        ) {
            var intereses = 0;
            setDetalle({
                ...detalle,
                totalpagar: Number(importe) + Number(intereses),
                intereses,
            });
        } else if (detalle.enganche === "S") {
            var intereses = 0;
            setDetalle({
                ...detalle,
                totalpagar: Number(importe) + Number(intereses),
                intereses,
            });
        } else {
            var intereses =
                importe === 0 || tasa === 0 || dias === 0
                    ? 0
                    : ((Number(importe) * Number(tasa)) / 100 / 360) * Number(dias);
            setDetalle({
                ...detalle,
                totalpagar: Number(importe) + Number(intereses),
                intereses,
            });
        }
    }, [detalle.importe, detalle.tasa, detalle.dias, detalle.enganche]);

    useEffect(() => {
        if (detalle.vencimiento !== "" && detalle.inicio_interes !== "") {

            const fechaInicio = new Date(detalle.inicio_interes);
            const fechaVencimiento = new Date(detalle.vencimiento);

            const diferenciaMs = fechaVencimiento - fechaInicio;
            const diferenciaDias = Math.ceil(diferenciaMs / (1000 * 60 * 60 * 24));

            // Si quieres guardar la diferencia en el estado:
            setDetalle((prev) => ({ ...prev, dias: diferenciaDias }));
        }
    }, [detalle.inicio_interes, detalle.vencimiento]);
    return (
        <Modal open={open}>
            <div className="dash-clientes-credito-crear-solicitud-modal">
                <LoaderScreen loader={loader} />
                <div className="dash-clientes-credito-crear-detalle-financiamiento-modal-title">
                    DETALLE DEL FINANCIAMIENTO
                </div>
                <div className="plantilla-screen-efecto-a">
                    <div className="plantilla-screen-efecto-bl"></div>
                    <div className="plantilla-screen-efecto-circle"></div>
                    <div className="plantilla-screen-efecto-br"></div>
                </div>

                <div className="dash-clientes-credito-crear-solicitud-modal-container-financiamiento">
                    <TextField
                        fullWidth
                        // disabled={state.tipo_solicitud === "C" ? true : false}
                        size="small"
                        label="¿Se cobrara interés?"
                        variant="outlined"
                        select
                        type="text"
                        className="cel-0-1"
                        onChange={({ target }) => {
                            setDetalle({ ...detalle, enganche: target.value });
                        }}
                        value={detalle.enganche}
                        sx={{
                            "& .MuiInputBase-root": {
                                height: "35px", // Cambia el valor para ajustar la altura
                            },
                        }}
                    >
                        <MenuItem value="S">NO</MenuItem>
                        <MenuItem value="N">SI</MenuItem>
                    </TextField>

                    <TextField
                        fullWidth
                        size="small"
                        label="Inicio de calculo de interés"
                        variant="outlined"
                        className="cel-1-1"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Agriculture fontSize="small" />
                                </InputAdornment>
                            ),
                        }}
                        type="date"
                        onChange={({ target }) => {
                            setDetalle({ ...detalle, inicio_interes: target.value });
                        }}
                        value={detalle.inicio_interes}
                    ></TextField>

                    <TextField
                        fullWidth
                        size="small"
                        label="Vencimiento"
                        variant="outlined"
                        className="cel-1-2"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Agriculture fontSize="small" />
                                </InputAdornment>
                            ),
                        }}
                        type="date"
                        onChange={({ target }) => {
                            setDetalle({ ...detalle, vencimiento: target.value });
                        }}
                        value={detalle.vencimiento}
                    ></TextField>

                    <TextField
                        className="cel-2"
                        size="small"
                        label="Tasa %"
                        variant="outlined"
                        type="number"
                        error={detalle.btasa}
                        // onKeyUp={(input) => Moneda(input.target)}
                        onChange={({ target }) => {
                            ValOnlyNumber("tasa", target.value, onChange, true, 10);
                        }}
                        value={detalle.tasa}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <PercentIcon />
                                </InputAdornment>
                            ),
                        }}
                        inputProps={{
                            style: { textAlign: "right" },
                        }}
                    />
                    <TextField
                        className="pr-5"
                        size="small"
                        label="Dias"
                        variant="outlined"
                        type="text"
                        error={detalle.bdias}
                        onChange={({ target }) => {
                            ValTextAndNumber("dias", target.value, onChange, true, 10);
                        }}
                        value={detalle.dias}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start"></InputAdornment>
                            ),
                        }}
                        disabled={true}
                        inputProps={{
                            style: { textAlign: "right" },
                        }}
                    />
                    <TextField
                        className=" cel-4"
                        size="small"
                        id="financiamineto"
                        label="Importe a Financiar"
                        variant="outlined"
                        type="text"
                        error={detalle.bimporte}
                        onChange={({ target }) => {
                            ValTextAndNumber("importe", target.value, onChange, true, 10);
                        }}
                        // onFocus={onFocus}
                        // onBlur={(e) => onBlur(e, "importe")}
                        onKeyUp={(input) => Moneda(input.target)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <AttachMoneyIcon />
                                </InputAdornment>
                            ),
                        }}
                        inputProps={{
                            style: { textAlign: "right" },
                        }}
                    />
                    <TextField
                        className="cel-5"
                        fullWidth
                        size="small"
                        label="Intereses"
                        variant="outlined"
                        type="text"
                        id="intereses"
                        value={FormatMoney(detalle.intereses)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <AttachMoneyIcon />
                                </InputAdornment>
                            ),
                        }}
                        disabled={true}
                        inputProps={{
                            style: { textAlign: "right" },
                        }}
                    ></TextField>

                    <TextField
                        disabled={true}
                        className="cel-6"
                        size="small"
                        label="Total a Pagar"
                        variant="outlined"
                        type="text"
                        value={FormatMoney(detalle.totalpagar)}
                        onFocus={onFocus}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <AttachMoneyIcon />
                                </InputAdornment>
                            ),
                        }}
                        inputProps={{
                            style: { textAlign: "right" },
                        }}
                    ></TextField>
                </div>

                <div className="dash-clientes-credito-crear-solicitud-modal-button-container">
                    <Button onClick={onClose} variant="contained" color="error">
                        Cerrar
                    </Button>
                    <Button variant="contained" onClick={() => onGuardar()}>
                        Agregar
                    </Button>
                </div>
            </div>
        </Modal>
    )
}
